var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { getDevices } from '../../../helpers/utils';
import { addAudioDevices } from '../../../store/slices/roomSettingsSlice';
import { useAppDispatch } from '../../../store';
const MicrophoneModal = ({ show, onCloseMicrophoneModal, }) => {
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const [selectedMic, setSelectMic] = useState('');
    const [devices, setDevices] = useState([]);
    const dispatch = useAppDispatch();
    useEffect(() => {
        const getDeviceMics = async () => {
            const mics = await getDevices('audioinput');
            const audioDevices = [];
            const options = mics.map((mic) => {
                const device = {
                    id: mic.deviceId,
                    label: mic.label,
                };
                audioDevices.push(device);
                return (_jsx("option", { value: mic.deviceId, children: mic.label }, mic.deviceId));
            });
            setDevices(options);
            setSelectMic(mics[0].deviceId);
            if (audioDevices.length) {
                dispatch(addAudioDevices(audioDevices));
            }
        };
        getDeviceMics();
    }, [dispatch]);
    const selectOrClose = (onlyClose = false) => {
        onCloseMicrophoneModal(onlyClose ? undefined : selectedMic);
    };
    const render = () => {
        return (_jsx(Transition, { show: show, enter: "transition duration-100 ease-out", enterFrom: "transform scale-95 opacity-0", enterTo: "transform scale-100 opacity-100", leave: "transition duration-75 ease-out", leaveFrom: "transform scale-100 opacity-100", leaveTo: "transform scale-95 opacity-0", children: _jsx(Dialog, { open: show, onClose: () => false, className: "share-microphone-popup-wrap fixed z-[99999] inset-0 overflow-y-auto", children: _jsxs("div", { className: "flex items-center justify-center min-h-screen", children: [_jsx(Dialog.Overlay, { className: "fixed inset-0 bg-black opacity-30" }), _jsxs("div", { className: "popup-inner bg-white dark:bg-darkPrimary w-full max-w-sm rounded-3xl shadow-header relative px-6 py-14", children: [_jsxs("button", { className: "close-btn absolute top-8 right-6 w-[25px] h-[25px] outline-none", type: "button", onClick: () => selectOrClose(true), children: [_jsx("span", { className: "inline-block h-[1px] w-[20px] bg-primaryColor dark:bg-darkText absolute top-0 left-0 rotate-45" }), _jsx("span", { className: "inline-block h-[1px] w-[20px] bg-primaryColor dark:bg-darkText absolute top-0 left-0 -rotate-45" })] }), _jsx(Dialog.Title, { className: "mb-6 dark:text-darkText", children: t('footer.modal.select-microphone') }), _jsx("div", { className: "col-span-6 sm:col-span-3", children: _jsx("select", { value: selectedMic, onChange: (e) => setSelectMic(e.target.value), className: "mt-1 block w-full py-2 px-3 border border-gray-300 bg-transparent dark:border-darkText dark:text-darkText rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm", children: devices }) }), _jsx("div", { className: "py-3 text-right", children: _jsx("button", { className: "inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primaryColor hover:bg-secondaryColor focus:outline-none", onClick: () => selectOrClose(), children: t('join') }) })] })] }) }) }));
    };
    return _jsx(_Fragment, { children: render() });
};
_react_refresh_temp_1 = MicrophoneModal;
$RefreshReg$(_react_refresh_temp_1, "MicrophoneModal");
_react_refresh_temp_2(MicrophoneModal, "hPC8f+MiIfckdydiGHkg+JTChLw=", false, () => [useTranslation, useAppDispatch]);
export default MicrophoneModal;
